<template>
    <div class="row">
        <div class='col-md-3 day-item'>
            <span class="date"> {{ dayUpcomingReservation[0].start_date | moment-date }}</span>
        </div>
        <div class="col-md-9">
            <div @click="redirectToOrder(booking)" v-for='(booking, index) in dayUpcomingReservation' class='item' :key="index">
                <span><i class="circle-arrow"></i></span>
                <span class="hours hint-text">De {{ booking.start_date | moment-booking-hour }} à {{ booking.end_date | moment-booking-hour }}</span>
                <h4 class="text-success">{{ booking.suborder.offer.distributed_product.agency.name }} - {{ booking.product.name }}</h4>
                <span>Société: {{ booking.suborder.suborderable.customer.name }} ({{ booking.suborder.suborderable.customer.erp_id }})</span>
                <span>Représentant légal: {{ decodedRepresentative(booking) }}</span>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.row {
    border-bottom: 1px solid #ddd;
    margin: 15px;
}

.date {
    display: block;
    padding-top: 15px;
    font-size: 16px;
    line-height: 1.4em;
}

.item {
    display: flex;
    flex-direction: column;
    position: relative;
    background: transparent;
    padding: 15px;
    &:hover {
        cursor: pointer;
        background: #FAFAFA;
    }
    h4 {
        margin: 0;
        font-size: 16px;
        line-height: 1.4em;
    }
    span {
        color: #575757;
        &:first-child {
        position:absolute;
        // left:-30px;
        // top: 2px;
        left: -30px;
        top: 17px;
        }
        &.hours {
            position: absolute;
            right: 15px;
            top: 17px;
            // right: 0;
            // top: 2px;
        }
    }
}
</style>

<script type="text/babel">

    export default {
        name: "UpcomingReservationsItem",

        props: ['dayUpcomingReservation'],

        methods: {
            decodedRepresentative (booking) {
                return `${booking.suborder.suborderable.customer.main_representative.civility} ${booking.suborder.suborderable.customer.main_representative.first_name} ${booking.suborder.suborderable.customer.main_representative.last_name}`
            },

            redirectToOrder (booking) {
                this.$store.commit('customer/HIGHLIGHT_ORDER', booking.suborder.suborderable.id)
                this.$store.commit('tabs/customer/TAB_ACTIVATION', 1)
                this.$router.push({
                    name: 'customer',
                    params: {
                        id: booking.customer_id
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Dashboard/UpcomingReservations/UpcomingReservationsItem.vue